import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({
  role,
  restrictForSeller = false,
  redirectPath = "/",
}) => {
  const { userType } = useSelector((state) => state.login);
  if (restrictForSeller && userType === "owner") {
    // If seller tries to access a restricted route
    return <Navigate to="/seller/dashboard" />;
  }
  if (role && userType !== role) {
    // If the role doesn't match, redirect to their dashboard
    return (
      <Navigate
        to={userType === "owner" ? "/seller/dashboard" : "/buyer/products"}
      />
    );
  }

  // If the role matches, render the nested routes
  return <Outlet />;
};

export default ProtectedRoute;
